import { gql } from '@apollo/client';

export const BILDERIT_MACHINE_GROUP = 'BILDERIT' as const;

export const ADD_BILDERIT_MACHINE_INPUT = [
  'name',
  'type_id',
  'power',
  'brand',
  { name: 'counter', schema: ['start', 'end', 'type'] },
  'preferred_counter_type',
  'model',
  'owner',
  'year',
  'fuel_type',
  'replacement_value',
  'weight',
  'domain',
  'serial_number',
  'engine_number',
  'observations',
  'photo_ids',
];

export const UPDATE_BILDERIT_MACHINE_INPUT = [
  'name',
  'type_id',
  'power',
  'brand',
  { name: 'counter', schema: ['start', 'end', 'type'] },
  'model',
  'owner',
  'year',
  'fuel_type',
  'replacement_value',
  'weight',
  'domain',
  'serial_number',
  'engine_number',
  'observations',
  'photo_ids',
];

export const COMPANY_WITH_TOTALS_FIELDS = gql`
  fragment CompanyWithTotalsFields on CompanyWithTotals {
    company {
      id
      name
    }
    users
    projects
    heavy_equipments
    trucks
    vehicles
    fixed_assets
    fuel_tanks
    maintenance_plans
    documents
    users_seen_30d
    last_seen_at
  }
`;

export const COMPANY_ACTIVITY_FIELDS = gql`
  fragment CompanyActivityFields on CompanyActivitySummary {
    companyId
    activeUserCount
    totalActions
    lastActivityDate
  }
`;

export const GET_COMPANY_ACTIVITY = gql`
  ${COMPANY_ACTIVITY_FIELDS}
  query GetCompanyActivity($from: LocalDate!, $to: LocalDate!) {
    getCompanyActivity(from: $from, to: $to) {
      ...CompanyActivityFields
    }
  }
`;

export const GET_All_COMPANIES_FOR_PROJECT_OPTIONS = gql`
  query GetAllCompaniesForProjectOptions {
    getAllCompanies {
      items {
        ...AllCompaniesForSuperRootFields
      }
    }
  }
  fragment AllCompaniesForSuperRootFields on Company {
    id
    name
    slug
    logo_url
    modules_enabled {
      module_id
      end_date
    }
    projects {
      id
      name
      slug
      business_unit {
        id
        name
        slug
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($username: String!) {
    deleteUserByUsername(username: $username)
  }
`;

export const ENABLE_BILDERIT_MODULE = gql`
  mutation EnableBilderitModule($input: EnableBilderitModuleInput!) {
    enableBilderitModule(input: $input)
  }
`;

export const DISABLE_BILDERIT_MODULE = gql`
  mutation DisableBilderitModule($input: DisableBilderitModuleInput!) {
    disableBilderitModule(input: $input)
  }
`;

export const ENABLE_CREATE_COMPANY = gql`
  mutation EnableToCreateCompany($input: EnableToCreateCompanyInput!) {
    enableToCreateCompany(input: $input)
  }
`;

export const DISABLE_CREATE_COMPANY = gql`
  mutation DisableToCreateCompany($input: DisableToCreateCompanyInput!) {
    disableToCreateCompany(input: $input)
  }
`;

export const GET_COMPANIES_WITH_TOTALS = gql`
  query GetCompaniesWithTotals {
    getCompaniesWithTotals {
      items {
        ...CompanyWithTotalsFields
      }
    }
  }
`;

export const CHANGE_COMPANY_ROOT = gql`
  mutation ChangeCompanyRoot($companyId: Int!, $newRootId: Int!) {
    changeCompanyRoot(companyId: $companyId, newRootId: $newRootId) {
      id
    }
  }
`;

export const GET_COMPANY_CREATORS = gql`
  query GetCompanyCreators {
    getEnabledToCreateCompanyUsers
  }
`;

export const SYNC_MACHINES_STATUS = gql`
  mutation SyncMachinesStatus($input: SyncMachinesStatusInput!) {
    syncMachinesStatus(input: $input) {
      ... on SuccessResult {
        result
      }
      ... on ServerError {
        errorCode
        message
      }
    }
  }
`;

export const SYNC_MACHINE_COUNTERS = gql`
  mutation SyncMachineCounters($input: SyncMachineCountersInput!) {
    syncMachineCounters(input: $input) {
      ... on SuccessResult {
        result
      }
      ... on ServerError {
        errorCode
        message
      }
    }
  }
`;

export const PREVIEW_BILDERIT_REPORT = gql`
  mutation PreviewBilderitReport($input: PreviewBilderitReportInput!) {
    previewBilderitReport(input: $input) {
      ... on SuccessResult {
        result
      }
      ... on ServerError {
        errorCode
        message
      }
    }
  }
`;

export const LINK_TRACKER_TO_BTRACK = gql`
  mutation LinkToBTrack($tracker_id: Int!) {
    linkToBTrack(tracker_id: $tracker_id)
  }
`;

export const UNLINK_TRACKER_FROM_BTRACK = gql`
  mutation UnlinkFromBTrack($tracker_id: Int!) {
    unlinkFromBTrack(tracker_id: $tracker_id)
  }
`;
